<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_button">
        <span>模板列表</span>
      </div>
      <div class="right_table">
        <el-table ref="table" v-loading="loading" :data="fileTable" border highlight-current-row height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="序号" type="index" width="60" />
          <el-table-column label="文件名称" prop="fileName" min-width="200px" />
          <el-table-column label="创建人" prop="operatorName" min-width="120px" />
          <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
          <el-table-column label="最近更新时间" prop="updateTime" min-width="120px" />
          <el-table-column label="备注" prop="remark" min-width="120px" />
          <el-table-column label="操作" align="center" min-width="160px">
            <template slot-scope="scope">
              <span style="cursor: pointer;color:var(--theme-color)" @click="downloadFile(scope.row)">下载</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  components: { majorTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      fileTable: [],
      loading: false
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  methods: {
    detailBtn(val) {
      this.selectDocumentList(val.specId);
    },
    // 列表
    async selectDocumentList(specId) {
      try {
        this.loading = true;
        this.fileTable = [];
        const res = await standardTemplateService.selectDocumentList({
          fileId: specId,
          standardType: 10,
          enterpriseId: this.enterpriseId
        });
        this.fileTable = res.data || [];
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 右侧下载
    async downloadFile(row) {
      standardTemplateService.downloadStandardDocument(row.fileId).then(response => {
        if (response.type === "application/json") {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            const jsonData = JSON.parse(fileReader.result);
            // 后台信息
            this.$message({ message: jsonData.message, type: "error" });
          };
          fileReader.readAsText(response); // 或者读取response.data
        } else {
          const link = document.createElement("a");
          const blob = new Blob([response], {
            type: "application/octet-stream"
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(row.fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$left_width: 256px;
$top_height: 35px;
$minddle_height: 40px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 0;
    left: 10px;
    width: $left_width;
    border-right: 1px solid #ebefff;

    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      right: 0;
      li {
        display: flex;
        border-bottom: 0;
        align-items: center;
        padding: 2px 30px;
        cursor: pointer;
        font-size: 14px;
        line-height: 26px;
        color: var(--key-color);
        img {
          margin-right: 8px;
        }
      }
      .active {
        background: rgba(85, 132, 255, 0.1);
      }
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 10px;
    .right_button {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ebefff;
      span {
        font-size: 16px;
        font-weight: 600;
        line-height: $top_height;
        color: var(--key-color);
      }
    }
    .right_table {
      position: absolute;
      top: $top_height + 30px;
      left: 10px;
      bottom: 40px;
      right: 20px;
    }
  }
}
</style>
